/* =============================
Wuthering Waves V10 Catalog
Auto-generated from config
Pattern: unified
============================= */
(function () {
  const API_SOURCES = {
    'green': {
      name: 'Green Source (Scraper)',
      enabled: true,
      priority: 1,
      idPrefix: 'WW04',
      prefixes: ['mc5_', 'mc_'],
      unwanted: new Set(['Asia', 'SEA', 'America', '男', '女', 'Gender', 'Server', '停驻之烟', '擎渊怒涛', '浩境粼光', '漪澜浮录', 'Europe', 'HMT', 'HK,TW,MAC', '衍射女', '衍射男', 'Email', 'Level', '性别', '区服']),
      nameKey: 'name',
      idKey: 'id',
      imageKey: 'pic'
    },
    'mxwy': {
      name: 'MXWY Source (V2)',
      enabled: true,
      priority: 2,
      idPrefix: 'WW02',
      prefixes: ['mc5_', 'mc_'],
      unwanted: new Set(['停驻之烟', '擎渊怒涛', '浩境粼光', '漪澜浮录', 'America', 'Europe', 'Asia', 'SEA', 'HMT', '衍射女', '衍射男', 'Gender', 'Server', '男', '女', 'HK,TW,MAC', 'Email', 'Level', '性别', '区服']),
      nameKey: 'name',
      idKey: 'id',
      imageKey: 'role_img'
    },
    'bssy': {
      name: 'BSSY Source (V1)',
      enabled: true,
      priority: 3,
      idPrefix: 'WW03',
      prefixes: ['mc5_', 'mc_'],
      unwanted: new Set(['停驻之烟', '擎渊怒涛', '浩境粼光', '漪澜浮录', 'America', 'Europe', 'Asia', 'SEA', 'HMT', 'HK,TW,MAC', '衍射女', '衍射男', '男', '女', 'Gender', 'Server', 'Email', 'Level', '性别', '区服']),
      nameKey: 'name',
      idKey: 'card_id',
      imageKey: 'img_url'
    },
    'chushi': {
      name: 'Chushi Premium',
      enabled: true,
      priority: 4,
      idPrefix: 'WW01',
      prefixes: ['mc5_', 'mc_'],
      unwanted: new Set(['停驻之烟', '擎渊怒涛', '浩境粼光', '漪澜浮录', 'America', 'Europe', 'Asia', 'SEA', 'HMT', 'HK,TW,MAC', '衍射女', '衍射男', '男', '女', 'Gender', 'Server', 'Email', 'Level', '性别', '区服']),
      nameKey: 'name',
      idKey: 'id',
      imageKey: 'img_url'
    },
    'kikiyx': {
      name: 'Kikiyx Scrap',
      enabled: true,
      priority: 5,
      idPrefix: 'WW05',
      prefixes: ['mc5_', 'mc_'],
      unwanted: new Set(['停驻之烟', '擎渊怒涛', '浩境粼光', '漪澜浮录', 'America', 'Europe', 'Asia', 'SEA', 'HMT', 'HK,TW,MAC', '衍射女', '衍射男', '男', '女', 'Gender', 'Server', 'Email', 'Level', '性别', '区服']),
      nameKey: 'name',
      idKey: 'id',
      imageKey: 'img_url'
    }
  };

  const GREEN_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy?source=green';
  const MXWY_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy?source=mxwy';
  const BSSY_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy?source=bssy';
  const CHUSHI_BASE = 'https://www.chushi.shop/gamefun/api/game/frontend';
  const KIKIYX_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy?source=kikiyx';
  let selected = {}; // Keyed by Display Name

  // Lazy Loading State
  let allSearchResults = [];
  let renderedCount = 0;
  const BATCH_SIZE = 24;
  let resultObserver = null;

  const initResultObserver = () => {
    if (resultObserver) resultObserver.disconnect();
    resultObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && renderedCount < allSearchResults.length) {
        renderBatch();
      }
    }, { rootMargin: '200px' });
  };

  const updateSelectedUI = () => {
    const totalCount = Object.values(selected).reduce((sum, sel) => sum + (sel.count || 0), 0);
    const el = document.querySelector("#selectedCount");
    if (el) el.textContent = totalCount;
  };

  const scrollToResults = () => {
    document.querySelector("#results")?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const showToast = () => {
    const toast = document.querySelector("#toast");
    if (!toast) return;
    toast.classList.remove('hidden', 'show');
    toast.offsetHeight;
    toast.classList.add('show');
    setTimeout(() => { toast.classList.remove('show'); setTimeout(() => toast.classList.add('hidden'), 300); }, 3000);
  };

  const copyToClipboard = text => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(showToast).catch(() => fallbackCopy(text));
    } else fallbackCopy(text);
  };

  const fallbackCopy = text => {
    const ta = document.createElement('textarea');
    ta.value = text; ta.style.cssText = 'position:fixed;left:-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); showToast(); } catch (e) { }
    document.body.removeChild(ta);
  };

  const escapeHtml = s => String(s || '').replace(/[&<>"]|'/g, m => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"'
      : '&quot;', "'": '&#39;'
  }[m])); /*======Settings & Translations======*/
  let appSettings = {
    translations_json: '{}',
    images_json: '{}',
    api_toggles: {},
    api_priority: {}
  };

  const logger = {
    log: (...args) => { if (appSettings.enable_debug) console.log(...args); },
    warn: (...args) => { if (appSettings.enable_debug) console.warn(...args); },
    error: (...args) => { console.error(...args); } // Errors always show
  };

  try {
    const el = document.getElementById('catalog-settings-wuwa-v10');
    if (el) appSettings = JSON.parse(el.textContent);

    if (appSettings.api_toggles) {
      Object.keys(API_SOURCES).forEach(apiId => {
        if (appSettings.api_toggles.hasOwnProperty(apiId)) {
          API_SOURCES[apiId].enabled = appSettings.api_toggles[apiId] === true;
        }
        if (appSettings.api_names && appSettings.api_names[apiId]) {
          API_SOURCES[apiId].name = appSettings.api_names[apiId];
        }
        if (appSettings.api_priority && appSettings.api_priority.hasOwnProperty(apiId)) {
          API_SOURCES[apiId].priority = parseInt(appSettings.api_priority[apiId], 10);
        }
      });
    }
  } catch (e) { }

  let nameTranslationsMap = {};
  try {
    const json = JSON.parse(appSettings.translations_json || '{}');
    Object.entries(json).forEach(([key, val]) => {
      const standardValue = typeof val === 'string' ? val.trim() : val;
      key.split('|').forEach(k => { if (k.trim()) nameTranslationsMap[k.trim()] = standardValue; });
    });
  } catch (e) { }

  let customImagesMap = {};
  try {
    const json = JSON.parse(appSettings.images_json || '{}');
    Object.entries(json).forEach(([key, val]) => {
      const imageUrl = typeof val === 'string' ? val.trim() : val;
      key.split('|').forEach(k => { if (k.trim()) customImagesMap[k.trim()] = imageUrl; });
    });
  } catch (e) { }

  const translateName = name => nameTranslationsMap[name] || name;
  const getCustomImage = name => customImagesMap[name] || null;

  function privateToPublicID(privateID, source) {
    if (!privateID) return '';
    const srcConf = API_SOURCES[source];
    // Use the display name as prefix, fallback to 'ACC' if not found.
    // Replace spaces with underscores or remove them for a cleaner prefix.
    const prefix = srcConf?.name ? srcConf.name.replace(/\s+/g, '') : 'ACC';
    const reversed = String(privateID).split('').reverse();
    for (let i = 0; i + 1 < reversed.length; i += 2) {
      [reversed[i], reversed[i + 1]] = [reversed[i + 1], reversed[i]];
    }
    return prefix + '-' + reversed.join('');
  }

  function publicToPrivateID(publicID) {
    if (!publicID) return '';
    let core = publicID;
    if (publicID.includes('-')) {
      core = publicID.split('-')[1];
    } else if (publicID.length > 5 && (publicID.startsWith('WW') || publicID.length > 12)) {
      // Handle legacy format briefly if it's very long or already has some markers
      // Actually, safest is to just try the swap logic on whatever core we have
      if (publicID.length >= 5) core = publicID.substring(2, publicID.length - 2);
    }
    let chars = core.split('');
    for (let i = 0; i + 1 < chars.length; i += 2) {
      [chars[i], chars[i + 1]] = [chars[i + 1], chars[i]];
    }
    return chars.reverse().join('');
  }

  const normalizeString = (name, prefixes) => {
    if (!name) return '';
    let n = String(name).trim();
    if (prefixes) prefixes.forEach(p => { if (n.startsWith(p)) n = n.slice(p.length); });
    return n;
  };

  const getResultsArray = (payload, apiId) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;

    const config = API_SOURCES[apiId];
    // Try mapping root first
    if (config && config.root) {
      const parts = config.root.split('.');
      let cur = payload;
      for (const p of parts) if (cur) cur = cur[p];
      if (Array.isArray(cur)) return cur;
    }

    // Try common patterns
    return payload.results || payload.items || payload.data?.items || payload.data || (Array.isArray(payload.c) ?
      payload.c : []);
  };

  const updateThumbDisplay = (thumb, key) => {
    const count = selected[key]?.count || 0;
    const existingBadge = thumb.querySelector('.count-badge');
    if (count > 0) {
      thumb.classList.add('selected');
      if (existingBadge) existingBadge.textContent = count;
      else {
        const b = document.createElement('div');
        b.className = 'count-badge';
        b.textContent = count;
        thumb.querySelector('.thumb-img-container').appendChild(b);
      }
    } else {
      thumb.classList.remove('selected');
      if (existingBadge) existingBadge.remove();
    }
  };

  /* ====== Resource Loading ====== */
  const loadResources = () => {
    logger.log('🚀 [Catalog] Initializing resource loading...');
    const resourcePromises = [];
    if (API_SOURCES['green'].enabled) {
      const url = GREEN_BASE + '&action=' +
        encodeURIComponent('getCarts') + '&game=' +
        encodeURIComponent('105') + '&'.slice(0, -1);
      logger.log('📡 [Catalog] Fetching Green Source (Scraper) characters:', url);
      resourcePromises.push(fetch(url).then(r => r.json()).catch(err => {
        logger.warn('⚠️ [Catalog] Green Source (Scraper) fetch failed:', err);
        return null;
      }));
    } else {
      logger.log('🚫 [Catalog] Green Source (Scraper) is disabled.');
      resourcePromises.push(Promise.resolve(null));

    }
    if (API_SOURCES['mxwy'].enabled) {
      const url = MXWY_BASE + '&action=' +
        encodeURIComponent('image') + '&url=' +
        encodeURIComponent('http://mxwy.ltd/api/card/?game=鸣潮&tag=五星') + '&'.slice(0, -1);
      const config = API_SOURCES['mxwy'];
      logger.log('📡 [Catalog] Fetching ' + config.name + ' characters:', url);
      resourcePromises.push(fetch(url).then(r => r.json()).catch(err => {
        logger.warn('⚠️ [Catalog] ' + config.name + ' fetch failed:', err);
        return null;
      }));
    } else {
      const config = API_SOURCES['mxwy'];
      logger.log('🚫 [Catalog] ' + config.name + ' is disabled.');
      resourcePromises.push(Promise.resolve(null));

    }
    if (API_SOURCES['bssy'].enabled) {
      const url = BSSY_BASE + '&action=' +
        encodeURIComponent('image') + '&url=' +
        encodeURIComponent('http://bssy.top/api/card/?game=鸣潮&tag=五星') + '&'.slice(0, -1);
      const config = API_SOURCES['bssy'];
      logger.log('📡 [Catalog] Fetching ' + config.name + ' characters:', url);
      resourcePromises.push(fetch(url).then(r => r.json()).catch(err => {
        logger.warn('⚠️ [Catalog] ' + config.name + ' fetch failed:', err);
        return null;
      }));
    } else {
      const config = API_SOURCES['bssy'];
      logger.log('🚫 [Catalog] ' + config.name + ' is disabled.');
      resourcePromises.push(Promise.resolve(null));

    }
    if (API_SOURCES['chushi'].enabled) {
      const url = CHUSHI_BASE + '/resource/get?game_id=' +
        encodeURIComponent('2') + '&'.slice(0, -1);
      const config = API_SOURCES['chushi'];
      logger.log('📡 [Catalog] Fetching ' + config.name + ' characters:', url);
      resourcePromises.push(fetch(url).then(r => r.json()).catch(err => {
        logger.warn('⚠️ [Catalog] ' + config.name + ' fetch failed:', err);
        return null;
      }));
    } else {
      const config = API_SOURCES['chushi'];
      logger.log('🚫 [Catalog] ' + config.name + ' is disabled.');
      resourcePromises.push(Promise.resolve(null));

    }
    if (API_SOURCES['kikiyx'].enabled) {
      const url = KIKIYX_BASE + '&action=' +
        encodeURIComponent('list') + '&'.slice(0, -1);
      const config = API_SOURCES['kikiyx'];
      logger.log('📡 [Catalog] Fetching ' + config.name + ' characters:', url);
      resourcePromises.push(fetch(url).then(r => r.json()).catch(err => {
        logger.warn('⚠️ [Catalog] ' + config.name + ' fetch failed:', err);
        return null;
      }));
    } else {
      const config = API_SOURCES['kikiyx'];
      logger.log('🚫 [Catalog] ' + config.name + ' is disabled.');
      resourcePromises.push(Promise.resolve(null));

    }

    Promise.all(resourcePromises).then(results => {
      logger.log('✅ [Catalog] All network requests complete.');
      let resultIdx = 0;
      const apiData = {};
      {
        const raw = results[resultIdx++];
        const config = API_SOURCES['green'];
        logger.log('📦 [Catalog] Processing ' + config.name + ' raw data:', raw);

        const dataArray = getResultsArray(raw, 'green');
        apiData['green'] = Array.isArray(dataArray) ? dataArray : [];
        logger.log('📊 [Catalog] ' + config.name + ' processed items:', apiData['green'].length);

        // Static server mapping from configuration
        const sMap = {};
        sMap['Asia'] = '7893';
        sMap['SEA'] = '7894';
        sMap['America'] = '7895';
        window._greenServerMap = sMap;
        logger.log('🖥️ [Catalog] ' + config.name + ' servers mapped statically:', Object.keys(sMap).length);
      }
      {
        const raw = results[resultIdx++];
        const config = API_SOURCES['mxwy'];
        logger.log('📦 [Catalog] Processing ' + config.name + ' raw data:', raw);

        const dataArray = getResultsArray(raw, 'mxwy');
        apiData['mxwy'] = Array.isArray(dataArray) ? dataArray : [];
        logger.log('📊 [Catalog] ' + config.name + ' processed items:', apiData['mxwy'].length);

        // Static server mapping from configuration
        const sMap = {};
        sMap['Asia'] = '13898';
        sMap['SEA'] = '13901';
        sMap['Europe'] = '13899';
        sMap['America'] = '13897';
        window._mxwyServerMap = sMap;
        logger.log('🖥️ [Catalog] ' + config.name + ' servers mapped statically:', Object.keys(sMap).length);
      }
      {
        const raw = results[resultIdx++];
        const config = API_SOURCES['bssy'];
        logger.log('📦 [Catalog] Processing ' + config.name + ' raw data:', raw);

        const dataArray = getResultsArray(raw, 'bssy');
        apiData['bssy'] = Array.isArray(dataArray) ? dataArray : [];
        logger.log('📊 [Catalog] BSSY Source (V1) processed items:', apiData['bssy'].length);

        // Static server mapping from configuration
        const sMap = {};
        sMap['Asia'] = '13898';
        sMap['SEA'] = '13901';
        sMap['Europe'] = '13899';
        sMap['America'] = '13897';
        window._bssyServerMap = sMap;
        logger.log('🖥️ [Catalog] BSSY Source (V1) servers mapped statically:', Object.keys(sMap).length);
      }
      {
        const raw = results[resultIdx++];
        logger.log('📦 [Catalog] Processing Chushi Premium raw data:', raw);

        const dataArray = getResultsArray(raw, 'chushi');
        apiData['chushi'] = Array.isArray(dataArray) ? dataArray : [];
        logger.log('📊 [Catalog] Chushi Premium processed items:', apiData['chushi'].length);

        // Static server mapping from configuration
        const sMap = {};
        window._chushiServerMap = sMap;
        logger.log('🖥️ [Catalog] Chushi Premium servers mapped statically:', Object.keys(sMap).length);
      }
      {
        const raw = results[resultIdx++];
        logger.log('📦 [Catalog] Processing Kikiyx Scrap raw data:', raw);

        const dataArray = getResultsArray(raw, 'kikiyx');
        apiData['kikiyx'] = Array.isArray(dataArray) ? dataArray : [];
        logger.log('📊 [Catalog] Kikiyx Scrap processed items:', apiData['kikiyx'].length);

        // Static server mapping from configuration
        const sMap = {};
        sMap['Asia'] = 'A01';
        sMap['SEA'] = 'A02';
        sMap['Europe'] = 'A03';
        sMap['America'] = 'A04';
        sMap['HMT'] = 'A05';
        window._kikiyxServerMap = sMap;
        logger.log('🖥️ [Catalog] Kikiyx Scrap servers mapped statically:', Object.keys(sMap).length);
      }

      const merged = {};
      if (apiData['green'] && apiData['green'].length > 0) {
        logger.log('🖇️ [Catalog] Merging Green Source (Scraper) into registry...');
        const prefixes = ['mc5_', 'mc_'];
        const unwanted = new Set(['Asia', 'SEA', 'America', '男', '女', 'Gender', 'Server', '停驻之烟', '擎渊怒涛', '浩境粼光', '漪澜浮录', 'Europe', 'HMT', 'HK,TW,MAC', '衍射女', '衍射男', 'Email', 'Level', '性别', '区服']);

        apiData['green'].forEach(item => {
          const rawName = item.name || item.name;
          const norm = normalizeString(rawName, prefixes);
          if (unwanted.has(norm)) return;

          const displayLabel = translateName(norm);
          let itemImg = item.pic || item.img_url || item.role_img || item.card_img;

          if (!merged[displayLabel]) {
            merged[displayLabel] = {
              displayLabel: displayLabel,
              normName: norm, // Store the primary normalized name for image lookup
              rawNames: new Set([rawName, norm, displayLabel]),
              _green_id: String(item.id || item.id),
              img: itemImg
            };
          } else {
            merged[displayLabel]._green_id = String(item.id || item.id);
            if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
            merged[displayLabel].rawNames.add(rawName);
            merged[displayLabel].rawNames.add(norm);
          }
        });
      }
      if (apiData['mxwy'] && apiData['mxwy'].length > 0) {
        logger.log('🖇️ [Catalog] Merging MXWY Source (V2) into registry...');
        const prefixes = ['mc5_', 'mc_'];
        const unwanted = new Set(['停驻之烟', '擎渊怒涛', '浩境粼光', '漪澜浮录', 'America', 'Europe', 'Asia', 'SEA', 'HMT', '衍射女', '衍射男', 'Gender', 'Server', '男', '女', 'HK,TW,MAC', 'Email', 'Level', '性别', '区服']);

        apiData['mxwy'].forEach(item => {
          const rawName = item.name || item.name;
          const norm = normalizeString(rawName, prefixes);
          if (unwanted.has(norm)) return;

          const displayLabel = translateName(norm);
          let itemImg = item.role_img || item.img_url || item.role_img || item.card_img;

          if (!merged[displayLabel]) {
            merged[displayLabel] = {
              displayLabel: displayLabel,
              normName: norm, // Store the primary normalized name for image lookup
              rawNames: new Set([rawName, norm, displayLabel]),
              _mxwy_id: String(item.id || item.id),
              img: itemImg
            };
          } else {
            merged[displayLabel]._mxwy_id = String(item.id || item.id);
            if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
            merged[displayLabel].rawNames.add(rawName);
            merged[displayLabel].rawNames.add(norm);
          }
        });
      }
      if (apiData['bssy'] && apiData['bssy'].length > 0) {
        logger.log('🖇️ [Catalog] Merging BSSY Source (V1) into registry...');
        const prefixes = ['mc5_', 'mc_'];
        const unwanted = new Set(['停驻之烟', '擎渊怒涛', '浩境粼光', '漪澜浮录', 'America', 'Europe', 'Asia', 'SEA', 'HMT', 'HK,TW,MAC', '衍射女', '衍射男', '男', '女', 'Gender', 'Server', 'Email', 'Level', '性别', '区服']);

        apiData['bssy'].forEach(item => {
          const rawName = item.name || item.name;
          const norm = normalizeString(rawName, prefixes);
          if (unwanted.has(norm)) return;

          const displayLabel = translateName(norm);
          let itemImg = item.img_url || item.img_url || item.role_img || item.card_img;

          if (!merged[displayLabel]) {
            merged[displayLabel] = {
              displayLabel: displayLabel,
              normName: norm, // Store the primary normalized name for image lookup
              rawNames: new Set([rawName, norm, displayLabel]),
              _bssy_id: String(item.card_id || item.id),
              img: itemImg
            };
          } else {
            merged[displayLabel]._bssy_id = String(item.card_id || item.id);
            if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
            merged[displayLabel].rawNames.add(rawName);
            merged[displayLabel].rawNames.add(norm);
          }
        });
      }
      if (apiData['chushi'] && apiData['chushi'].length > 0) {
        logger.log('🖇️ [Catalog] Merging Chushi Premium into registry...');
        const prefixes = ['mc5_', 'mc_'];
        const unwanted = new Set(['停驻之烟', '擎渊怒涛', '浩境粼光', '漪澜浮录', 'America', 'Europe', 'Asia', 'SEA', 'HMT', 'HK,TW,MAC', '衍射女', '衍射男', '男', '女', 'Gender', 'Server', 'Email', 'Level', '性别', '区服']);

        apiData['chushi'].forEach(item => {
          const rawName = item.name || item.name;
          const norm = normalizeString(rawName, prefixes);
          if (unwanted.has(norm)) return;

          const displayLabel = translateName(norm);
          let itemImg = item.img_url || item.img_url || item.role_img || item.card_img;

          if (!merged[displayLabel]) {
            merged[displayLabel] = {
              displayLabel: displayLabel,
              normName: norm, // Store the primary normalized name for image lookup
              rawNames: new Set([rawName, norm, displayLabel]),
              _chushi_id: String(item.id || item.id),
              img: itemImg
            };
          } else {
            merged[displayLabel]._chushi_id = String(item.id || item.id);
            if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
            merged[displayLabel].rawNames.add(rawName);
            merged[displayLabel].rawNames.add(norm);
          }
        });
      }
      if (apiData['kikiyx'] && apiData['kikiyx'].length > 0) {
        logger.log('🖇️ [Catalog] Merging Kikiyx Scrap into registry...');
        const prefixes = ['mc5_', 'mc_'];
        const unwanted = new Set(['停驻之烟', '擎渊怒涛', '浩境粼光', '漪澜浮录', 'America', 'Europe', 'Asia', 'SEA', 'HMT', 'HK,TW,MAC', '衍射女', '衍射男', '男', '女', 'Gender', 'Server', 'Email', 'Level', '性别', '区服']);

        apiData['kikiyx'].forEach(item => {
          const rawName = item.name || item.name;
          const norm = normalizeString(rawName, prefixes);
          if (unwanted.has(norm)) return;

          const displayLabel = translateName(norm);
          let itemImg = item.img_url || item.img_url || item.role_img || item.card_img;

          if (!merged[displayLabel]) {
            merged[displayLabel] = {
              displayLabel: displayLabel,
              normName: norm, // Store the primary normalized name for image lookup
              rawNames: new Set([rawName, norm, displayLabel]),
              _kikiyx_id: String(item.id || item.id),
              img: itemImg
            };
          } else {
            merged[displayLabel]._kikiyx_id = String(item.id || item.id);
            if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
            merged[displayLabel].rawNames.add(rawName);
            merged[displayLabel].rawNames.add(norm);
          }
        });
      }

      let allItems = Object.values(merged);

      // --- Sort characters by character_order_source if set ---
      const orderSource = appSettings.character_order_source;
      if (orderSource && apiData[orderSource]) {
        logger.log('秤️ [Catalog] Sorting characters by', orderSource, 'order...');
        const orderMap = new Map();
        const refItems = apiData[orderSource];
        const prefixes = API_SOURCES[orderSource].prefixes || [];
        const nKey = API_SOURCES[orderSource].nameKey || 'name';

        let rank = 0;
        refItems.forEach(item => {
          const raw = item[nKey] || item.name;
          if (!raw) return;
          const norm = normalizeString(raw, prefixes);
          const std = translateName(norm);
          if (!orderMap.has(std)) orderMap.set(std, rank++);
        });

        allItems.sort((a, b) => {
          const rankA = orderMap.has(a.displayLabel) ? orderMap.get(a.displayLabel) : 10000;
          const rankB = orderMap.has(b.displayLabel) ? orderMap.get(b.displayLabel) : 10000;
          if (rankA !== rankB) return rankA - rankB;
          return a.displayLabel.localeCompare(b.displayLabel);
        });
      }

      logger.log('🎨 [Catalog] Rendering', allItems.length, 'total unique characters.');
      window._characterImageMap = {};
      allItems.forEach(it => {
        if (it.img) window._characterImageMap[it.displayLabel] = it.img;
      });
      renderFilters(allItems);
    }).catch(e => {
      console.error('❌ [Catalog] Critical merge error:', e);
      document.querySelector("#filters").innerHTML = 'Failed to load character list. Check console for details.';
    });
  };

  /* ====== Filter Rendering ====== */
  const renderFilters = (items) => {
    const container = document.querySelector("#filters");
    if (!container) return;
    container.innerHTML = '';

    items.forEach(it => {
      const thumb = document.createElement('div');
      const displayLabel = it.displayLabel;

      // Resolve custom image: try normalized name first (old behavior), then standard label, then raw
      let imgSrc = getCustomImage(it.normName) || getCustomImage(it.displayLabel);
      if (!imgSrc) {
        for (let r of it.rawNames) {
          imgSrc = getCustomImage(r);
          if (imgSrc) break;
        }
      }
      const finalImg = imgSrc || it.img;

      thumb.className = 'thumb';
      thumb.dataset.greenId = it._green_id || '';
      thumb.dataset.mxwyId = it._mxwy_id || '';
      thumb.dataset.bssyId = it._bssy_id || '';
      thumb.dataset.chushiId = it._chushi_id || '';
      thumb.dataset.kikiyxId = it._kikiyx_id || '';
      thumb.dataset.displayLabel = displayLabel;

      thumb.innerHTML = `<div class="thumb-img-container"><img alt="${displayLabel}" src="${finalImg || ''}"
          loading="lazy" /></div>
      <div class="label">${displayLabel}</div>`;
      thumb.onclick = () => {
        const key = thumb.dataset.displayLabel;
        if (selected[key]) {
          selected[key].count++;
        } else {
          selected[key] = {
            count: 1,
            greenId: thumb.dataset.greenId,
            mxwyId: thumb.dataset.mxwyId,
            bssyId: thumb.dataset.bssyId,
            chushiId: thumb.dataset.chushiId,
            kikiyxId: thumb.dataset.kikiyxId,
            rawNames: Array.from(it.rawNames)
          };
        }
        updateThumbDisplay(thumb, key);
        updateSelectedUI();
      };
      container.appendChild(thumb);
    });
  };

  /* ====== Sorting Logic ====== */
  const calculateAccountTotal = (item) => {
    let total = 0;
    const apiConf = API_SOURCES[item._src];
    if (!apiConf) return 0;

    // Normalize item data structure
    let has = {};
    if (item.deck_info) {
      try { has = typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info; } catch (e) { }
    } else if (item.items) {
      item.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
    }

    const prefixes = apiConf.prefixes;
    const unwanted = apiConf.unwanted;

    Object.entries(has).forEach(([name, count]) => {
      const norm = normalizeString(name, prefixes);
      if (!unwanted.has(norm)) {
        total += (parseInt(count) || 0);
      }
    });
    return total;
  };

  const sortResults = () => {
    const sortMode = document.getElementById('sortSelect')?.value || 'default';
    if (sortMode === 'default') {
      // If needed we could re-sort by priority or original order if we stored it, 
      // but for now let's just leave it or re-fetch. 
      // Actually simplest is just to not do anything special or re-run renderResults logic if we had the original payload.
      // Since we don't keep the original payload easily, we might just sort by default priority logic if 'default'.
      allSearchResults.sort((a, b) => (a._p || 0) - (b._p || 0));
    } else {
      allSearchResults.sort((a, b) => {
        const totalA = calculateAccountTotal(a);
        const totalB = calculateAccountTotal(b);
        if (sortMode === 'count_desc') return totalB - totalA;
        if (sortMode === 'count_asc') return totalA - totalB;
        return 0;
      });
    }

    // Reset rendering
    renderedCount = 0;
    document.querySelector("#results").innerHTML = '';
    renderBatch();
  };

  /* ====== Rendering Logic ====== */
  // Lazy Loading State
  // allSearchResults is already defined in global scope

  const renderResults = (payload) => {
    const res = document.querySelector("#results");
    res.innerHTML = '';

    allSearchResults = []; // Reset global results
    renderedCount = 0;

    // Combine all results into one array
    ['green', 'mxwy', 'bssy', 'chushi', 'kikiyx'].forEach(source => {
      if (payload[source] && payload[source].results) {
        payload[source].results.forEach(item => {
          item._src = source;
          // add priority
          item._p = API_SOURCES[source].priority;
          allSearchResults.push(item);
        });
      }
    });

    if (allSearchResults.length === 0) {
      res.innerHTML = '<div class="no-data">No accounts found matching criteria.</div>';
      return;
    }

    // Filter by ID if input is not empty
    // ID search removed as per request

    // Sort logic
    const sortMode = document.getElementById('sortSelect')?.value || 'default';
    if (sortMode === 'default') {
      allSearchResults.sort((a, b) => (a._p || 0) - (b._p || 0));
    } else {
      allSearchResults.sort((a, b) => {
        const totalA = calculateAccountTotal(a);
        const totalB = calculateAccountTotal(b);
        if (sortMode === 'count_desc') return totalB - totalA;
        if (sortMode === 'count_asc') return totalA - totalB;
        return 0;
      });
    }

    // Setup Observer
    initResultObserver();

    // Initial Render
    renderBatch();
  };
  /* ====== SEARCH LOGIC ====== */
  const performSearch = () => {
    const selectedKeys = Object.keys(selected).filter(k => selected[k].count > 0);
    if (selectedKeys.length === 0) {
      alert("Please select at least one character before searching.");
      return;
    }

    const res = document.querySelector("#results");
    res.innerHTML = '<div class="no-data">Searching...</div>';
    scrollToResults();
    const serverSelect = document.querySelector("#serverSelect");
    const server = serverSelect ? serverSelect.value : '';
    const promises = [];


    if (API_SOURCES['green'].enabled) {
      let c = [];
      selectedKeys.forEach(k => {
        if (selected[k].greenId) {
          for (let i = 0; i < selected[k].count; i++)
            c.push(selected[k].greenId);
        }
      }); const sid = window._greenServerMap?.[server] || ''; if (server && sid)
        c = [sid, ...c]; const url = GREEN_BASE + '&key=' +
          encodeURIComponent(c.join(',')); promises.push(fetch(url).then(r => r.json()).catch(() => ({
            results: []
          })));
    } else promises.push(Promise.resolve({ results: [] }));
    if (API_SOURCES['mxwy'].enabled) {
      let c = [];
      selectedKeys.forEach(k => {
        if (selected[k].mxwyId) {
          for (let i = 0; i < selected[k].count; i++)
            c.push(selected[k].mxwyId);
        }
      }); const sid = window._mxwyServerMap?.[server] || ''; if (server && sid)
        c = [sid, ...c]; const nativeSearchUrl = 'http://mxwy.ltd/api/deck/?game='
          + encodeURIComponent('鸣潮') + '&limit=&sid=&deckid=&asort=desc&cards=' + encodeURIComponent(c.join('|')); const
            url = MXWY_BASE + '&url=' + encodeURIComponent(nativeSearchUrl);
      promises.push(fetch(url).then(r => r.json()).catch(() => ({ results: [] })));
    } else promises.push(Promise.resolve({ results: [] }));
    if (API_SOURCES['bssy'].enabled) {
      let c = [];
      selectedKeys.forEach(k => {
        if (selected[k].bssyId) {
          for (let i = 0; i < selected[k].count; i++)
            c.push(selected[k].bssyId);
        }
      }); const sid = window._bssyServerMap?.[server] || ''; if (server && sid)
        c = [sid, ...c]; const nativeSearchUrl = 'http://bssy.top/api/deck/?game='
          + encodeURIComponent('鸣潮') + '&limit=&sid=&deckid=&asort=desc&cards=' + encodeURIComponent(c.join('|')); const
            url = BSSY_BASE + '&url=' + encodeURIComponent(nativeSearchUrl);
      promises.push(fetch(url).then(r => r.json()).catch(() => ({ results: [] })));
    } else promises.push(Promise.resolve({ results: [] }));
    if (API_SOURCES['chushi'].enabled) {
      let url = CHUSHI_BASE + '/resource/search?game_id=2&code=&description=' +
        encodeURIComponent(server);
      const g = {};
      selectedKeys.forEach(k => { if (selected[k].chushiId) g[selected[k].chushiId] = selected[k].count; });
      url += '&groups=' + encodeURIComponent(JSON.stringify(g));
      promises.push(fetch(url).then(r => r.json()).catch(() => ({ data: { items: [] } })));
    } else promises.push(Promise.resolve({ results: [] }));
    if (API_SOURCES['kikiyx'].enabled) {
      const body = new URLSearchParams();
      selectedKeys.forEach(k => {
        if (selected[k].kikiyxId) {
          for (let i = 0; i < selected[k].count; i++)
            body.append('cards', selected[k].kikiyxId);
        }
      }); if (server) body.append('server', server);
      promises.push(fetch(KIKIYX_BASE, {
        method: 'POST', headers: {
          'Content-Type'
            : 'application/x-www-form-urlencoded'
        }, body: body.toString()
      }).then(r => r.json()).catch(() => ({
        results: []
      })));
    } else promises.push(Promise.resolve({ results: [] }));

    Promise.all(promises).then(responses => {
      const payload = {}; payload.green = responses[0]; payload.mxwy = responses[1]; payload.bssy = responses[2]; payload.chushi = responses[3]; payload.kikiyx = responses[4];

      if (payload.green) {
        let items = getResultsArray(payload.green, 'green');
        items = items.filter(acc => {
          let has = {};
          if (acc.deck_info) {
            try { has = typeof acc.deck_info === 'string' ? JSON.parse(acc.deck_info) : acc.deck_info; } catch (e) { }
          } else if (acc.items) {
            acc.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
          }
          return selectedKeys.every(k => {
            const req = selected[k];
            return req.rawNames.some(rn => (has[rn] || 0) >= req.count);
          });
        });
        // Store filtered items back into the payload
        payload.green = { results: items };
      }
      if (payload.mxwy) {
        let items = getResultsArray(payload.mxwy, 'mxwy');
        if (server) {
          items = items.filter(d => {
            let di = {}; try { di = typeof d.deck_info === 'string' ? JSON.parse(d.deck_info) : d.deck_info; }
            catch (e) { }
            const prefixes = ['mc5_', 'mc_'];
            return di && Object.keys(di).some(k => normalizeString(k, prefixes) === server);
          });
        }
        items = items.filter(acc => {
          let has = {};
          if (acc.deck_info) {
            try { has = typeof acc.deck_info === 'string' ? JSON.parse(acc.deck_info) : acc.deck_info; } catch (e) { }
          } else if (acc.items) {
            acc.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
          }
          return selectedKeys.every(k => {
            const req = selected[k];
            return req.rawNames.some(rn => (has[rn] || 0) >= req.count);
          });
        });
        // Store filtered items back into the payload
        payload.mxwy = { results: items };
      }
      if (payload.bssy) {
        let items = getResultsArray(payload.bssy, 'bssy');
        if (server) {
          items = items.filter(d => {
            let di = {}; try { di = typeof d.deck_info === 'string' ? JSON.parse(d.deck_info) : d.deck_info; }
            catch (e) { }
            const prefixes = ['mc5_', 'mc_'];
            return di && Object.keys(di).some(k => normalizeString(k, prefixes) === server);
          });
        }
        items = items.filter(acc => {
          let has = {};
          if (acc.deck_info) {
            try { has = typeof acc.deck_info === 'string' ? JSON.parse(acc.deck_info) : acc.deck_info; } catch (e) { }
          } else if (acc.items) {
            acc.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
          }
          return selectedKeys.every(k => {
            const req = selected[k];
            return req.rawNames.some(rn => (has[rn] || 0) >= req.count);
          });
        });
        // Store filtered items back into the payload
        payload.bssy = { results: items };
      }
      if (payload.chushi) {
        let items = getResultsArray(payload.chushi, 'chushi');
        items = items.filter(acc => {
          let has = {};
          if (acc.deck_info) {
            try { has = typeof acc.deck_info === 'string' ? JSON.parse(acc.deck_info) : acc.deck_info; } catch (e) { }
          } else if (acc.items) {
            acc.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
          }
          return selectedKeys.every(k => {
            const req = selected[k];
            return req.rawNames.some(rn => (has[rn] || 0) >= req.count);
          });
        });
        // Store filtered items back into the payload
        payload.chushi = { results: items };
      }
      if (payload.kikiyx) {
        let items = getResultsArray(payload.kikiyx, 'kikiyx');
        if (server) {
          items = items.filter(d => {
            let di = {}; try { di = typeof d.deck_info === 'string' ? JSON.parse(d.deck_info) : d.deck_info; }
            catch (e) { }
            const prefixes = ['mc5_', 'mc_'];
            return di && Object.keys(di).some(k => normalizeString(k, prefixes) === server);
          });
        }
        items = items.filter(acc => {
          let has = {};
          if (acc.deck_info) {
            try { has = typeof acc.deck_info === 'string' ? JSON.parse(acc.deck_info) : acc.deck_info; } catch (e) { }
          } else if (acc.items) {
            acc.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
          }
          return selectedKeys.every(k => {
            const req = selected[k];
            return req.rawNames.some(rn => (has[rn] || 0) >= req.count);
          });
        });
        // Store filtered items back into the payload
        payload.kikiyx = { results: items };
      }
      renderResults(payload);
    }).catch(e => { console.error(e); res.innerHTML = 'Search failed.'; });
  };

  const renderBatch = () => {
    const res = document.querySelector("#results");
    const sentinel = document.getElementById('sentinel');
    if (sentinel) sentinel.remove();

    const batch = allSearchResults.slice(renderedCount, renderedCount + BATCH_SIZE);
    if (!batch.length) return;

    batch.forEach(a => {
      const apiConf = API_SOURCES[a._src];
      let items = Array.isArray(a.items) ? a.items : [];
      if (!items.length && a.deck_info) {
        try {
          const di = typeof a.deck_info === 'string' ? JSON.parse(a.deck_info) : a.deck_info;
          items = Object.entries(di || {}).map(([name, count]) => ({ name, count }));
        } catch (e) { }
      }
      const card = document.createElement('div');
      card.className = 'result-card';
      const rawId = a.code || a.account_id || a.name || a.id || "";
      const displayId = privateToPublicID(rawId, a._src);

      let info = [];
      let emailFound = false;

      let serverName = 'Unknown';
      if (a._src === 'chushi') {
        const desc = a.description || '';
        const p = desc.split(/[-—–]+/).map(s => s.trim());
        if (p.length >= 3) {
          serverName = p[1];
          info.push("Gender: " + (p[0] === '女' ? 'Female' : (p[0] === '男' ? 'Male' : p[0])));
          info.push("Server: " + serverName);
          info.push("Level: " + p[2]);
        } else if (desc) {
          info.push(desc);
        }
        if (desc.toLowerCase().includes('email')) emailFound = true;
      } else {
        let s = '', g = '', l = '';
        const di = a.deck_info ? (typeof a.deck_info === 'string' ? JSON.parse(a.deck_info) : a.deck_info) : {};
        Object.keys(di || {}).forEach(k => {
          const normK = normalizeString(k, apiConf.prefixes);
          if (normK === 'America' || normK === 'Europe' || normK === 'Asia' || normK === 'SEA' || normK === 'HMT') {
            s = normK;
            serverName = normK;
          }
          if (k.includes('女')) g = 'Female'; if (k.includes('男')) g = 'Male';
        });
        const src = a.source || ''; const lm = src.match(/等级[:：]([0-9]+)/); if (lm) l = lm[1];
        if (g) info.push("Gender: " + g);
        if (s) info.push("Server: " + s);
        if (l) info.push("Level: " + l);

        if (src.includes('企业')) { info.push("Email: Enterprise"); emailFound = true; }
        else if (src.includes('微软')) { info.push("Email: Microsoft"); emailFound = true; }
      }

      // Default Email for any source if not found
      if (!emailFound) {
        info.push("Email: Microsoft");
      }

      if (!appSettings.hide_source) {
        info.push("Source: " + API_SOURCES[a._src].name);
      }


      // Prepare character data for display and copy string
      const charData = items.filter(c => {
        const n = normalizeString(c.name, apiConf.prefixes);
        // Filter out Server Cards (A-series for Kikiyx, 13-series for BSSY)
        if (c.id && (String(c.id).startsWith('A') || String(c.id).startsWith('13'))) return false;
        // Filter out Metadata Cards (Gender, Server, etc)
        if (['Gender', 'Server', 'Email', 'Level', '性别', '区服'].some(ignore => n.includes(ignore))) return false;
        return !apiConf.unwanted.has(n);
      }).map(c => {
        const raw = c.name;
        const norm = normalizeString(raw, apiConf.prefixes);
        const std = translateName(norm);
        const cImg = getCustomImage(norm) || getCustomImage(std) || getCustomImage(raw);
        const img = cImg || c.img_url || c.role_img || window._characterImageMap?.[std] || '';
        return {
          html: `<div class="char"><img src="${img}" alt="${std}" onerror="this.style.opacity=.5" />
                <div class="cname">${std}</div>${c.count > 1 ? '<div class="char-count">x' + c.count + '</div>' : ''}
              </div>`,
          name: std,
          count: c.count || 1
        };
      });

      const charString = charData.flatMap(c => Array(c.count).fill(c.name)).join(',');
      const extendedId = `${displayId}----${serverName}----[${charString}]`;

      card.innerHTML = `<div class="result-header">
        <div>Account ID: <strong>${escapeHtml(displayId)}</strong></div>
        <div class="header-btns">
          <button class="copy-btn">Copy ID</button>
          <button class="price-btn">Price Check</button>
        </div>
      </div>
      <div class="result-info">${info.join(' | ')}</div>
      <div class="chars-row">${charData.map(c => c.html).join('')}</div>`;

      card.querySelector('.copy-btn').onclick = () => window.copyToClipboard(extendedId);
      card.querySelector('.price-btn').onclick = () => window.showPriceCheck(displayId, extendedId);

      res.appendChild(card);
    });

    renderedCount += batch.length;
    if (renderedCount < allSearchResults.length) {
      const s = document.createElement('div');
      s.id = 'sentinel';
      s.style.height = '100px';
      s.innerHTML = '<div style="text-align:center; padding: 20px; color: var(--text-muted);">Loading more results...</div>';
      res.appendChild(s);
      resultObserver.observe(s);
    }
  };

  const initPriceModal = () => {
    const modal = document.createElement('div');
    modal.id = 'priceCheckModal';
    modal.className = 'modal-backdrop hidden';
    modal.innerHTML = `
            <div class="modal-content">
              <div class="modal-header">
                <h3>Price Check Inquiry</h3>
                <button class="close-modal">&times;</button>
              </div>
              <div class="modal-body">
                <p class="step-header">Step 1: Copy Account ID</p>
                <div class="id-display-box highlighted">
                  <span>Account ID:</span>
                  <code id="modalAccountId">---</code>
                  <input type="hidden" id="modalFullId" value="">
                  <button class="copy-mini-btn" id="modalCopyBtn">Copy</button>
                </div>

                <div class="modal-divider"></div>

                <p class="step-header">Step 2: Choose Contact Method For Price Quotation</p>

                <div class="contact-row">
                  <div class="contact-option primary">
                    <div class="opt-icon">✨</div>
                    <div class="opt-details">
                      <strong>Direct Message</strong>
                      <a href="https://discord.com/users/477359052662243349" target="_blank" class="modal-btn">DM
                        Admin</a>
                    </div>
                  </div>

                  <div class="contact-option secondary">
                    <div class="opt-icon">🌸</div>
                    <div class="opt-details">
                      <strong>Join Server</strong>
                      <a href="https://discord.com/invite/exvg8GR8sk" target="_blank" class="modal-btn">Join & DM CL</a>
                    </div>
                  </div>
                </div>
                <p class="modal-hint"
                  style="text-align:center; margin-top:8px; font-size:0.8em; color:var(--text-muted); opacity:0.8;">
                  (Discord Tag: <code>gachamacha2025</code>)
                </p>
              </div>
            </div>
            `;
    document.body.appendChild(modal);

    const closeBtn = modal.querySelector('.close-modal');
    closeBtn.onclick = () => modal.classList.add('hidden');
    modal.onclick = (e) => {
      if (e.target === modal) modal.classList.add('hidden');
    };

    const cpBtn = modal.querySelector('#modalCopyBtn');
    cpBtn.onclick = () => {
      const fullId = document.querySelector('#modalFullId').value;
      copyToClipboard(fullId);
      cpBtn.textContent = 'Copied!';
      setTimeout(() => cpBtn.textContent = 'Copy', 2000);
    };
  };

  window.showPriceCheck = (id, fullId) => {
    const modal = document.querySelector("#priceCheckModal");
    if (!modal) return;
    document.querySelector("#modalAccountId").textContent = id;
    document.querySelector("#modalFullId").value = fullId || id;
    modal.classList.remove('hidden');
  };

  const sBtn = document.querySelector("#searchBtn");
  if (sBtn) sBtn.onclick = performSearch;

  const sortSel = document.querySelector("#sortSelect");
  if (sortSel) sortSel.onchange = sortResults;

  const cBtn = document.querySelector("#clearBtn");
  if (cBtn) cBtn.onclick = () => {
    selected = {};
    document.querySelectorAll('.thumb').forEach(t => {
      t.classList.remove('selected');
      t.querySelector('.count-badge')?.remove();
    });
    updateSelectedUI();
    document.querySelector("#results").innerHTML = '';
  };
  window.copyToClipboard = copyToClipboard;
  initPriceModal();
  loadResources();
})();